import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-408">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-409">
          {label}
        </label>}
      <input id={inputId} className={`w-full px-4 py-3 rounded-md border ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300 focus:ring-cyan-500 focus:border-cyan-500'} shadow-sm focus:outline-none focus:ring-2 transition-colors ${className}`} {...props} data-id="element-410" />
      {error && <p className="mt-1 text-sm text-red-600" data-id="element-411">{error}</p>}
    </div>;
}